import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { ModalityTextResponse } from "@/core/types";

import { getModalityText } from "../queryFunctions/getModalityText";
import { memberCarePlanKeys } from "../keyFactory";

type UseModalityTextProps<TData = ModalityTextResponse> = {
  patientId: string;
  select?: (data: ModalityTextResponse) => TData;
};

type ModalityTextQueryOptions = UseQueryOptions<
  ModalityTextResponse,
  unknown,
  ModalityTextResponse,
  ReturnType<typeof memberCarePlanKeys.modalityText>
>;

export function useModalityText<TData = ModalityTextResponse>({
  patientId,
  select,
}: UseModalityTextProps<TData>) {
  return useQuery({
    ...optionFactory(patientId),
    select,
  });
}

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getModalityText(patientId),
    queryKey: memberCarePlanKeys.modalityText(patientId),
  } satisfies ModalityTextQueryOptions;
}
